<template>
  <div class="gallery-wrap">
    <header class="section gallery-header" :style="{ background : success && (info.bg_color ? info.bg_color : '#f5d784')}">
      <div class="container">
        <div class="columns header is-vcentered is-hidden-mobile">
          <div class="column">
            <h1 class="title is-1 is-spaced">{{ info.title }}</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
          <div class="column">
            <template v-if="info && info.video_url">
              <div class="image is-16by9">
                <div
                  class="iframe-wrap"
                  v-html="info.video_url"
                ></div>
              </div>
            </template>
            <template v-else-if="info.image">
              <div class="image">
                <img alt="..." :src="info.image" />
              </div>
            </template>
          </div>
        </div>
        <div class="columns header is-hidden-tablet">
          <div class="column">
            <h1 class="title is-1 is-spaced">Gallery - Take a Tour</h1>
            <p class="subtitle has-text-weight-medium">
              {{ info.desc }}
            </p>
          </div>
        </div>
      </div>
    </header>
    <parent-index v-if="config.shop_type == 1" :items="items" />
    <son-index v-if="config.shop_type == 0" :items="items" />
  </div>
</template>
<script>
import { galleryList } from "@/server/api.js";
import store from "@/store";
import ParentIndex from "./components/ParentIndex.vue";
import SonIndex from "./components/SonIndex.vue";

export default {
  components: {
    ParentIndex,
    SonIndex,
  },
  data() {
    return {
      items: [],
      info: {},
      success: false
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      try {
        const { status, data } = await galleryList({});
        if (status == 0) {
          this.items = data.items;
          this.info = data.info;
          this.success = true;
          setTimeout(()=>{
            var iframe = document.getElementsByTagName("iframe")
            for(let i = 0; i <= iframe.length-1; i++) {
              iframe[i].style.width = "100%";
              iframe[i].style.height = "100%";
            }
          }, 0)
        }
      } catch (error) {}
    },
  },
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}
.gallery-header {
  margin-top: 50px;
}
.section {
  padding: 3rem 1.5rem;
}
.image {
  display: block;
  position: relative;
}
.is-16by9 {
    padding-top: 56.25%;
}
.image img {
  display: block;
  height: 100%;
}
@media screen and (min-width: 1024px) {
  .section {
    padding: 3rem;
  }
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}
.columns:not(:last-child) {
  margin-bottom: 0rem;
}
.columns.is-vcentered {
  align-items: center;
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}
.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}
.tabs:not(:last-child),
.pagination:not(:last-child),
.message:not(:last-child),
.level:not(:last-child),
.breadcrumb:not(:last-child),
.block:not(:last-child),
.title:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.progress:not(:last-child),
.notification:not(:last-child),
.content:not(:last-child),
.box:not(:last-child) {
  margin-bottom: 1.5rem;
}
.title.is-1 {
  font-size: 3rem;
}
.subtitle {
  color: #757763;
  font-family: Quicksand, sans-serif;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 1.25;
}
.has-text-weight-medium {
  font-weight: 500 !important;
}
.image.is-16by9 {
  padding-top: 56.25%;
}
.image {
  display: block;
  position: relative;
}
@media screen and (min-width: 769px) {
  .is-hidden-tablet {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}

.columns:last-child {
  margin-bottom: -1.5rem;
}
.container {
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
}
@media screen and (min-width: 1024px) {
  .container {
    max-width: 960px;
  }
}
@media screen and (min-width: 1408px) {
  .container:not(.is-max-desktop):not(.is-max-widescreen) {
    max-width: 1344px;
  }
}
.img {
  max-width: 648px !important;
}
.columns.is-multiline {
  flex-wrap: wrap;
}
@media screen and (min-width: 769px) {
  .column.is-6,
  .column.is-6-tablet {
    flex: none;
    width: 50%;
  }
}
.image {
  display: block;
  position: relative;
}
.image img {
  display: block;
  height: auto;
  width: 100%;
}
@media screen and (max-width: 768px) {
  .is-hidden-mobile {
    display: none !important;
  }
}
@media screen and (min-width: 769px) {
  .column.is-7,
  .column.is-7-tablet {
    flex: none;
    width: 58.33333337%;
  }
  .column.is-4,
  .column.is-4-tablet {
    flex: none;
    width: 33.33333337%;
  }
  .column.is-12,
  .column.is-12-tablet {
    flex: none;
    width: 100%;
  }

  .column.is-3,
  .column.is-3-tablet {
    flex: none;
    width: 25%;
  }
  .column.is-5,
  .column.is-5-tablet {
    flex: none;
    width: 41.66666674%;
  }
}
.iframe-wrap {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/pages/gallery/index.vue